import { render, staticRenderFns } from "./SuratJalan.vue?vue&type=template&id=18a8b562&scoped=true&"
import script from "./SuratJalan.vue?vue&type=script&lang=js&"
export * from "./SuratJalan.vue?vue&type=script&lang=js&"
import style0 from "./SuratJalan.vue?vue&type=style&index=0&id=18a8b562&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a8b562",
  null
  
)

export default component.exports